import { useCallback } from 'react';

import type {
	SendBotEscalatedSessionEventProps,
	SendBotProductSearchEventProps,
	SendBotSearchResultEventProps,
	SendBotSessionTopicEventProps,
} from './types';
import { useTrackDibotGA4 } from './useTrackDibotGA4';

export const useTrackDibot = ({ storeId }: { storeId: string | null }) => {
	const {
		sendProductSearchEvent,
		sendSearchResultEvent,
		sendSessionTopicEvent,
		sendEscalatedSessionEvent,
	} = useTrackDibotGA4({
		storeId,
	});

	const trackProductSearch = useCallback(
		(props: SendBotProductSearchEventProps) => {
			try {
				sendProductSearchEvent(props);
			} catch (e) {
				console.error('Error sending bot product search event', e);
			}
		},
		[sendProductSearchEvent]
	);

	const trackSearchResult = useCallback(
		(props: SendBotSearchResultEventProps) => {
			try {
				sendSearchResultEvent(props);
			} catch (e) {
				console.error('Error sending bot search result event', e);
			}
		},
		[sendSearchResultEvent]
	);

	const trackSessionTopic = useCallback(
		(props: SendBotSessionTopicEventProps) => {
			try {
				sendSessionTopicEvent(props);
			} catch (e) {
				console.error('Error sending bot session topic event', e);
			}
		},
		[sendSessionTopicEvent]
	);

	const trackEscalatedSession = useCallback(
		(props: SendBotEscalatedSessionEventProps) => {
			try {
				sendEscalatedSessionEvent(props);
			} catch (e) {
				console.error('Error sending bot escalated session event', e);
			}
		},
		[sendEscalatedSessionEvent]
	);

	return { trackProductSearch, trackSearchResult, trackSessionTopic, trackEscalatedSession };
};
